import React, { useState } from 'react'
import './index.css'
import { Input } from 'antd'
import { BiSolidNavigation } from "react-icons/bi";
import useInquiries from '../../Config/hooks/Apis/useInquiries';
import useGeneralStore from '../../Store/generalStore';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewsLetter = (props) => {
    const [email, setEmail] = useState('');
    const { subscribeNewsletter } = useInquiries();
    const { setError, loading } = useGeneralStore();

    const handleSubscribe = async () => {
        const trimmedEmail = email.trim();

        if (!trimmedEmail) {
            setError('Please enter your email address.');
            return;
        }

        if (!EMAIL_REGEX.test(trimmedEmail)) {
            setError('Please enter a valid email address.');
            return;
        }

        const success = await subscribeNewsletter(trimmedEmail);
        if (success) {
            setEmail('');
        }
    };

    return (
        <div className={props.className}>
            <h3 className='main-heading text-2xl'>Sign up to our newsletter</h3>
            <p className='max-w-[400px] w-full mx-auto text-center'>
                Get exclusive offers, new fleet updates, and travel tips for your next classic car adventure. No spam—just the good stuff.
            </p>
            <Input
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onPressEnter={handleSubscribe}
                disabled={loading}
                className='w-72 h-10'
                placeholder='Enter Your email address'
                suffix={
                    <button
                        type='button'
                        aria-label='Subscribe to newsletter'
                        disabled={loading}
                        onClick={handleSubscribe}
                        className='p-2 flex items-center justify-center bg-[#a7f3fa] cursor-pointer border-0 disabled:opacity-60 disabled:cursor-not-allowed'
                    >
                        <BiSolidNavigation color='white' size={12} />
                    </button>
                }
            />
        </div>
    )
}

export default NewsLetter
